module.exports = __webpack_public_path__ + "static/media/urbanlinker.1da77597.png";